import api from '../api.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#customer #company_id					{ width: 10rem;		}
			#customer #id							{ width: 5rem; text-align: right;	}
			#customer #payment_term_id				{ width: 11rem; 	}
			#customer #payment_method				{ width: 11rem; 	}
			#customer #price_list_id				{ width: 11rem; 	}
			#customer #route_id					{ width: 14rem; 	}
			#customer #delivery_term				{ width: 4rem; 		}
			#customer #type							{ width: 4rem;		}
			#customer #nick							{ width: 18rem;		}
			#customer #name							{ width: 20rem; 	}
			#customer #email						{ width: 15rem;		}
			#customer #phone						{ width: 10rem;		}
			#customer #cpf							{ width: 10rem;		}
			#customer #cnpj							{ width: 11rem; 	}
			#customer #ie							{ width: 10rem; 	}
			#customer #ie_type						{ width: 11rem;		}
			#customer #billing_address_street		{ width: 20rem;		}
			#customer #billing_address_number		{ width: 5rem;		}
			#customer #billing_address_complement	{ width: 10rem;		}
			#customer #billing_address_district		{ width: 15rem;		}
			#customer #billing_address_state		{ width: 3.5rem;	}
			#customer #billing_address_city_id		{ width: 15rem;		}
			#customer #billing_address_zipcode		{ width: 6rem;		}
			#customer #delivery_address_street		{ width: 20rem;		}
			#customer #delivery_address_number		{ width: 5rem;		}
			#customer #delivery_address_complement	{ width: 10rem;		}
			#customer #delivery_address_district	{ width: 15rem;		}
			#customer #delivery_address_state		{ width: 3.5rem;	}
			#customer #delivery_address_city_id		{ width: 15rem;		}
			#customer #delivery_address_zipcode		{ width: 6rem;		}
			#customer fieldset						{ display: inline-block; }
			#customer .addr-hint					{ min-height: 2rem; align-items: center; }
			#customer .cep-hint					{ font-size: 0.85em; color: var(--muted, #666); }
			#customer .cda-section fieldset			{ display: block; width: 100%; box-sizing: border-box; margin-top: 1rem; }
			#customer .cda-table					{ width: 100%; font-size: 0.82em; border-collapse: collapse; margin-top: 0.4rem; }
			#customer .cda-table th, #customer .cda-table td { border-bottom: 1px solid var(--border, #ddd); padding: 0.25rem 0.4rem; text-align: left; }
			#customer .cda-table th				{ background: var(--th-bg, #f4f4f4); font-weight: 600; }
			#customer .cda-table tr.cda-disabled td { color: var(--muted, #999); text-decoration: line-through; }
			#customer .cda-form-area				{ padding: 0.75rem 0; margin-top: 0.5rem; border-top: 1px solid var(--border, #ddd); }
			#customer .cda-form-area b				{ display: block; margin-bottom: 0.4rem; }
			#customer .cda-msg					{ font-size: 0.82em; color: var(--muted, #666); margin: 0.4rem 0; }
		</style>
		<form id="customer" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="person_types">
			</datalist>
			<datalist id="ie_types">
			</datalist>
			<datalist id="states">
			</datalist>
			<datalist id="customer_routes">
			</datalist>
			<datalist id="payment_methods">
			</datalist>
			<datalist id="billing_cities">
			</datalist>
			<datalist id="delivery_cities">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do cliente">Cliente
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de personalidade jurídica">Tipo<sup>*</sup>
					<input id="type" type="text" list="person_types" required>
				</label>
				<label title="Condição de pagamento padrão">Condição de Pagto
					<input id="payment_term_id" type="text" list="payment_terms">
				</label>
				<label title="Forma de pagamento padrão para novos pedidos de saída">Pagamento
					<input id="payment_method" type="text" list="payment_methods">
				</label>
				<label title="Lista de preços vinculada ao cliente">Lista de Preços
					<input id="price_list_id" type="text" list="price_lists">
				</label>
				<label title="Rota de entrega do cliente">Rota
					<input id="route_id" type="text" list="customer_routes">
				</label>
				<label title="Prazo de entrega em dias">Prazo<sup>*</sup>
					<input id="delivery_term" type="text" placeholder="0" required>
				</label>
				<label title="Cliente é consumidor final?">Consumidor
					<input id="is_end_consumer" type="checkbox" checked>
				</label>
				<label title="Cliente inativo não aparece para novos pedidos de saída">Inativo
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb">
				<label title="Nome curto do cliente">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
				<label title="Nome ou razão social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="Número do CPF">CPF
					<input id="cpf" type="text" placeholder="000.000.000-00">
				</label>
				<label title="Número do CNPJ">CNPJ
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="Número da Inscrição Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscrição Estadual">Tipo IE
					<input id="ie_type" type="text" list="ie_types">
				</label>
			</div>
			<div class="fsb">
				<fieldset>
					<legend>Endereço de Faturamento</legend>
					<div class="fsb addr-hint">
						<label title="Usar o mesmo endereço de entrega para faturamento" style="display:flex;align-items:center;gap:0.5rem;">
							<input id="same_billing_delivery" type="checkbox"> Mesmo endereço de entrega
						</label>
					</div>
					<input type="hidden" id="billing_address_id">
					<div class="fsb">
						<label title="Nome da rua ou avenida">Logradouro
							<input id="billing_address_street" type="text">
						</label>
						<label title="Número">Número
							<input id="billing_address_number" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Complemento">Complemento
							<input id="billing_address_complement" type="text">
						</label>
						<label title="Bairro">Bairro
							<input id="billing_address_district" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Unidade Federativa">UF
							<input id="billing_address_state" type="text" list="states">
						</label>
						<label title="Município (ou digite CEP antes para preencher automaticamente)">Município
							<input id="billing_address_city_id" type="text" list="billing_cities">
						</label>
						<label title="CEP: digite e saia do campo para buscar nos Correios">CEP
							<input id="billing_address_zipcode" type="text" placeholder="00000-000">
						</label>
					</div>
				</fieldset>
				<fieldset>
					<legend>Endereço de Entrega</legend>
					<div class="fsb addr-hint">
						<span class="cep-hint" title="Consulta ViaCEP (base dos Correios)">Digite o CEP e saia do campo para preencher automaticamente</span>
					</div>
					<input type="hidden" id="delivery_address_id">
					<div class="fsb">
						<label title="Nome da rua ou avenida">Logradouro
							<input id="delivery_address_street" type="text">
						</label>
						<label title="Número">Número
							<input id="delivery_address_number" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Complemento">Complemento
							<input id="delivery_address_complement" type="text">
						</label>
						<label title="Bairro">Bairro
							<input id="delivery_address_district" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Unidade Federativa">UF
							<input id="delivery_address_state" type="text" list="states">
						</label>
						<label title="Município (ou digite CEP antes para preencher automaticamente)">Município
							<input id="delivery_address_city_id" type="text" list="delivery_cities">
						</label>
						<label title="CEP: digite e saia do campo para buscar nos Correios">CEP
							<input id="delivery_address_zipcode" type="text" placeholder="00000-000">
						</label>
					</div>
				</fieldset>
			</div>
			<div class="cda-section" style="width:100%;">
				<fieldset>
					<legend>Endereços Adicionais de Entrega <span id="cda-count" style="font-size:0.82em;color:var(--muted,#666);font-weight:normal;"></span></legend>
					<p id="cda-no-customer-msg" class="cda-msg">Salve o cliente primeiro para gerenciar endereços de entrega.</p>
					<div id="cda-list-area" style="display:none;">
						<table class="cda-table" id="cda-table">
							<thead>
								<tr>
									<th>Nome/Local</th>
									<th>Destinatário</th>
									<th>Logradouro</th>
									<th>Cidade/UF</th>
									<th>CEP</th>
									<th>Padrão</th>
									<th>Situação</th>
									<th></th>
								</tr>
							</thead>
							<tbody id="cda-tbody"></tbody>
						</table>
						<p id="cda-empty-msg" class="cda-msg" style="display:none;">Nenhum endereço adicional cadastrado.</p>
					</div>
					<div id="cda-form-area" class="cda-form-area" style="display:none;">
						<b id="cda-form-title">Novo Endereço</b>
						<div class="fsb">
							<label>Nome/Identificação<sup>*</sup>
								<input id="cda_name" type="text" style="width:18rem;" placeholder="Ex.: CD Campinas, Filial SP">
							</label>
							<label>Destinatário
								<input id="cda_receiver_name" type="text" style="width:15rem;">
							</label>
							<label>CNPJ/CPF Dest.
								<input id="cda_document" type="text" style="width:12rem;">
							</label>
							<label>Telefone
								<input id="cda_phone" type="text" style="width:10rem;">
							</label>
						</div>
						<div class="fsb">
							<label>Logradouro<sup>*</sup>
								<input id="cda_street" type="text" style="width:20rem;">
							</label>
							<label>Número
								<input id="cda_number" type="text" style="width:5rem;">
							</label>
							<label>Complemento
								<input id="cda_complement" type="text" style="width:10rem;">
							</label>
							<label>Bairro
								<input id="cda_district" type="text" style="width:12rem;">
							</label>
						</div>
						<div class="fsb">
							<label>CEP
								<input id="cda_zipcode" type="text" style="width:7rem;" placeholder="00000-000">
							</label>
							<label>Cidade<sup>*</sup>
								<input id="cda_city" type="text" style="width:14rem;">
							</label>
							<label>UF<sup>*</sup>
								<input id="cda_state" type="text" style="width:3.5rem;" maxlength="2" placeholder="SP">
							</label>
							<label>País
								<input id="cda_country" type="text" style="width:8rem;">
							</label>
							<label title="Marcar como endereço padrão deste cliente">Padrão
								<input id="cda_is_default" type="checkbox">
							</label>
						</div>
						<div class="fsb">
							<label>Observações
								<input id="cda_notes" type="text" style="width:34rem;">
							</label>
						</div>
						<div style="display:flex;gap:0.5rem;margin-top:0.4rem;">
							<button type="button" id="cda-save-btn" class="button">Salvar Endereço</button>
							<button type="button" id="cda-cancel-btn" class="button">Cancelar</button>
						</div>
					</div>
					<div id="cda-add-area" style="display:none;margin-top:0.4rem;">
						<button type="button" id="cda-add-btn" class="button" style="font-size:0.82em;">+ Adicionar Endereço de Entrega</button>
					</div>
				</fieldset>
			</div>
		<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#customer',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
			const sel = formset.form.selector;
			const typeEl = document.querySelector(`${sel} #type`);
			const cnpjEl = document.querySelector(`${sel} #cnpj`);
			const cnpjLabel = cnpjEl?.closest('label');
			const toggleCnpjForTypeL = () => {
				if (!typeEl || !cnpjEl) return;
				const isLocal = typeEl.value?.trim() === 'L';
				cnpjEl.placeholder = isLocal ? 'Cód. GSNet (ex.: 1233)' : '00.000.000/0000-00';
				cnpjEl.title = isLocal ? 'Código GSNet (alfanumérico, até 10 caracteres)' : 'Número do CNPJ';
				if (cnpjLabel) cnpjLabel.title = cnpjEl.title;
			};
			const ieTypeEl = document.querySelector(`${sel} #ie_type`);
			const toggleIeTypeRequired = () => {
				const isLocal = typeEl?.value?.trim().toUpperCase() === 'L' || typeEl?.value?.trim().toUpperCase() === 'LOCAL';
				if (ieTypeEl) ieTypeEl.required = !isLocal;
			};
			const ptEl = document.querySelector(`${sel} #payment_term_id`);
			const togglePaymentTermForTypeL = () => {
				if (!ptEl) return;
				const isLocal = typeEl?.value?.trim().toUpperCase() === 'L' || typeEl?.value?.trim().toUpperCase() === 'LOCAL';
				if (isLocal) {
					ptEl.value = '';
					ptEl.setAttribute('readonly', '');
				} else {
					ptEl.removeAttribute('readonly');
				}
			};
			typeEl?.addEventListener('change', () => { toggleCnpjForTypeL(); toggleIeTypeRequired(); togglePaymentTermForTypeL(); });
			formset.subscribe?.(['open'], () => {
				setTimeout(toggleCnpjForTypeL, 0);
				setTimeout(toggleIeTypeRequired, 0);
				setTimeout(togglePaymentTermForTypeL, 0);
				setTimeout(() => {
					['billing_address_state', 'delivery_address_state'].forEach(name => {
						const el = document.querySelector(`${sel} #${name}`);
						if (el?.value) el.dispatchEvent(new Event('change', { bubbles: true }));
					});
					if (sameAddrCb?.checked) copyDeliveryToBilling();
				}, 200);
			});
			setTimeout(toggleCnpjForTypeL, 0);
			setTimeout(toggleIeTypeRequired, 0);
			setTimeout(togglePaymentTermForTypeL, 0);
			const sameAddrCb = document.querySelector(`${sel} #same_billing_delivery`);
			const copyDeliveryToBilling = () => {
				if (!sameAddrCb?.checked) return;
				['street', 'number', 'complement', 'district', 'state', 'city_id', 'zipcode'].forEach(f => {
					const src = document.querySelector(`${sel} #delivery_address_${f === 'state' ? 'state' : f === 'city_id' ? 'city_id' : f}`);
					const dst = document.querySelector(`${sel} #billing_address_${f === 'state' ? 'state' : f === 'city_id' ? 'city_id' : f}`);
					if (src && dst) { dst.value = src.value; dst.dispatchEvent(new Event('change', { bubbles: true })); }
				});
			};
			sameAddrCb?.addEventListener('change', copyDeliveryToBilling);
			['street', 'number', 'complement', 'district', 'state', 'city_id', 'zipcode'].forEach(suffix => {
				const f = suffix === 'state' ? 'state' : suffix === 'city_id' ? 'city_id' : suffix;
				document.querySelector(`${sel} #delivery_address_${f}`)?.addEventListener('blur', copyDeliveryToBilling);
			});

			// ── Endereços adicionais de entrega ──────────────────────────────────────
			let _cdaData   = [];
			let _cdaEditId = null;

			const cda = id => document.querySelector(`${sel} #${id}`);
			const cdaEsc = v => String(v ?? '').replace(/[&<>"']/g, ch => ({
				'&': '&amp;',
				'<': '&lt;',
				'>': '&gt;',
				'"': '&quot;',
				"'": '&#39;',
			}[ch]));
			const CDA_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
			const cdaParseId = (raw) => {
				if (raw == null || String(raw).trim() === '') return null;
				const n = Number(String(raw).replace(/\./g, '').replace(',', '.'));
				return Number.isFinite(n) && n > 0 ? Math.trunc(n) : null;
			};
			const cdaResolveCompanyId = (raw) => {
				if (raw == null || String(raw).trim() === '') return null;
				const s = String(raw).trim();
				if (CDA_UUID.test(s)) return s;
				const list = document.querySelector(`${sel} datalist#companies`);
				const opt = list && [...list.options].find(
					o => String(o.value).trim() === s || String(o.textContent || '').trim() === s,
				);
				const v = opt?.value?.trim();
				return v && CDA_UUID.test(v) ? v : null;
			};
			const cdaCustomerId = () => {
				const vals = formset?.form?.getValues?.() || {};
				return cdaParseId(vals.id)
					?? cdaParseId(formset?.form?.getFieldBySelector?.('#id')?.getValue?.())
					?? cdaParseId(cda('id')?.value);
			};
			const cdaCompanyId = () => {
				const vals = formset?.form?.getValues?.() || {};
				return cdaResolveCompanyId(vals.company_id)
					?? cdaResolveCompanyId(formset?.form?.getFieldBySelector?.('#company_id')?.getValue?.())
					?? cdaResolveCompanyId(cda('company_id')?.value);
			};

			// IDs virtuais do cadastro principal (API) — não entram na grade de adicionais.
			// Inclui legado -1/-2 (antes colidia com “vazio” do datalist no pedido).
			const CDA_VIRTUAL_IDS = new Set([2000000001, 2000000002, -1, -2]);
			const cdaIsAdditional = (r) => r && !CDA_VIRTUAL_IDS.has(Number(r.id));

			const cdaShowList = () => {
				cda('cda-list-area').style.display = '';
				cda('cda-add-area').style.display = '';
				cda('cda-no-customer-msg').style.display = 'none';
			};

			const cdaShowNeedSave = (msg) => {
				const el = cda('cda-no-customer-msg');
				if (el) {
					el.textContent = msg || 'Salve o cliente primeiro para gerenciar endereços de entrega.';
					el.style.display = '';
				}
				const list = cda('cda-list-area');
				if (list) list.style.display = 'none';
				const add = cda('cda-add-area');
				if (add) add.style.display = 'none';
			};

			const cdaRenderTable = (rows) => {
				const tbody = cda('cda-tbody');
				const count = cda('cda-count');
				if (!tbody) return;
				tbody.innerHTML = '';
				const active = rows.filter(r => !r.is_disabled);
				if (count) count.textContent = rows.length ? `(${rows.length})` : '';
				if (!rows.length) {
					cda('cda-empty-msg').style.display = '';
					cda('cda-table').style.display = 'none';
					return;
				}
				cda('cda-empty-msg').style.display = 'none';
				cda('cda-table').style.display = '';
				rows.forEach(r => {
					const tr = document.createElement('tr');
					if (r.is_disabled) tr.classList.add('cda-disabled');
					const addrLine = [r.street, r.number, r.complement].filter(Boolean).join(', ');
					const cityUf   = [r.city, r.state].filter(Boolean).join('/');
					const padrao   = r.is_default ? '★' : '';
					const status   = r.is_disabled ? 'Inativo' : 'Ativo';
					tr.innerHTML = `
						<td>${cdaEsc(r.name)}</td>
						<td>${cdaEsc(r.receiver_name)}</td>
						<td>${cdaEsc(addrLine)}</td>
						<td>${cdaEsc(cityUf)}</td>
						<td>${cdaEsc(r.zipcode)}</td>
						<td style="text-align:center;">${padrao}</td>
						<td>${status}</td>
						<td style="white-space:nowrap;">
							<button type="button" class="button cda-edit-btn" data-id="${r.id}" style="font-size:0.78em;padding:0.1rem 0.4rem;">Editar</button>
							${!r.is_disabled
								? `<button type="button" class="button cda-disable-btn" data-id="${r.id}" style="font-size:0.78em;padding:0.1rem 0.4rem;margin-left:0.25rem;">Desativar</button>`
								: `<button type="button" class="button cda-enable-btn" data-id="${r.id}" style="font-size:0.78em;padding:0.1rem 0.4rem;margin-left:0.25rem;">Ativar</button>`
							}
						</td>`;
					tbody.appendChild(tr);
				});
			};

			const cdaLoadAddresses = async () => {
				const cid = cdaCustomerId();
				const comId = cdaCompanyId();
				if (!cid || !comId) {
					cdaShowNeedSave();
					return;
				}
				try {
					const result = await api.call(api.list_customer_delivery_addresses, comId, cid);
					const rows = Array.isArray(result) ? result : [];
					_cdaData = rows.filter(cdaIsAdditional);
					cdaShowList();
					cdaRenderTable(_cdaData);
				} catch (e) {
					cdaShowNeedSave(
						'Não foi possível carregar os endereços adicionais. Verifique a permissão de listagem ou tente novamente.',
					);
				}
			};

			const cdaClearForm = () => {
				['name','receiver_name','document','phone','zipcode','street','number','complement','district','city','state','notes'].forEach(f => {
					const el = cda(`cda_${f}`);
					if (el) el.value = '';
				});
				const defEl = cda('cda_is_default');
				if (defEl) defEl.checked = false;
				const countryEl = cda('cda_country');
				if (countryEl) countryEl.value = 'Brasil';
			};

			const cdaOpenForm = (title, addr = {}) => {
				_cdaEditId = addr.id || null;
				cda('cda-form-title').textContent = title;
				cda('cda_name').value         = addr.name          || '';
				cda('cda_receiver_name').value = addr.receiver_name || '';
				cda('cda_document').value      = addr.document      || '';
				cda('cda_phone').value         = addr.phone         || '';
				cda('cda_zipcode').value       = addr.zipcode       || '';
				cda('cda_street').value        = addr.street        || '';
				cda('cda_number').value        = addr.number        || '';
				cda('cda_complement').value    = addr.complement    || '';
				cda('cda_district').value      = addr.district      || '';
				cda('cda_city').value          = addr.city          || '';
				cda('cda_state').value         = addr.state         || '';
				cda('cda_country').value       = addr.country       || 'Brasil';
				cda('cda_notes').value         = addr.notes         || '';
				const defEl = cda('cda_is_default');
				if (defEl) defEl.checked = !!addr.is_default;
				cda('cda-form-area').style.display = '';
				cda('cda-add-btn').style.display = 'none';
				cda('cda_name').focus();
			};

			const cdaCloseForm = () => {
				_cdaEditId = null;
				cda('cda-form-area').style.display = 'none';
				cda('cda-add-btn').style.display = '';
				cdaClearForm();
			};

			const cdaSave = async () => {
				const cid = cdaCustomerId();
				const comId = cdaCompanyId();
				if (!cid || !comId) { alert('Salve o cliente antes de adicionar endereços.'); return; }
				const data = {
					name:          cda('cda_name')?.value?.trim(),
					receiver_name: cda('cda_receiver_name')?.value?.trim() || null,
					document:      cda('cda_document')?.value?.trim() || null,
					phone:         cda('cda_phone')?.value?.trim() || null,
					zipcode:       cda('cda_zipcode')?.value?.trim() || null,
					street:        cda('cda_street')?.value?.trim(),
					number:        cda('cda_number')?.value?.trim() || null,
					complement:    cda('cda_complement')?.value?.trim() || null,
					district:      cda('cda_district')?.value?.trim() || null,
					city:          cda('cda_city')?.value?.trim(),
					state:         cda('cda_state')?.value?.trim()?.toUpperCase(),
					country:       cda('cda_country')?.value?.trim() || 'Brasil',
					is_default:    cda('cda_is_default')?.checked || false,
					notes:         cda('cda_notes')?.value?.trim() || null,
				};
				try {
					if (_cdaEditId) {
						await api.call(api.update_customer_delivery_address, comId, cid, _cdaEditId, data);
					} else {
						await api.call(api.insert_customer_delivery_address, comId, cid, data);
					}
					cdaCloseForm();
					await cdaLoadAddresses();
				} catch (e) {
					// erro já exibido pelo notifyRejection via api.call
				}
			};

			// Botões estáticos
			cda('cda-add-btn')?.addEventListener('click', () => cdaOpenForm('Novo Endereço'));
			cda('cda-save-btn')?.addEventListener('click', cdaSave);
			cda('cda-cancel-btn')?.addEventListener('click', cdaCloseForm);

			// Delegação para botões dinâmicos da tabela
			cda('cda-tbody')?.addEventListener('click', async (e) => {
				const btn = e.target.closest('button');
				if (!btn) return;
				const addrId = Number(btn.dataset.id);
				const cid = cdaCustomerId();
				const comId = cdaCompanyId();
				if (btn.classList.contains('cda-edit-btn')) {
					const addr = _cdaData.find(a => a.id === addrId);
					if (addr) cdaOpenForm('Editar Endereço', addr);
				} else if (btn.classList.contains('cda-disable-btn')) {
					if (!confirm('Desativar este endereço?')) return;
					try {
						await api.call(api.patch_customer_delivery_address, comId, cid, addrId, { is_disabled: true });
						await cdaLoadAddresses();
					} catch (e) { /* exibido pelo api.call */ }
				} else if (btn.classList.contains('cda-enable-btn')) {
					try {
						await api.call(api.patch_customer_delivery_address, comId, cid, addrId, { is_disabled: false });
						await cdaLoadAddresses();
					} catch (e) { /* exibido pelo api.call */ }
				}
			});

			this._cdaCloseForm = cdaCloseForm;
			this._cdaLoadAddresses = cdaLoadAddresses;
		},
		afterEditSetValues(fs)
		{
			const form = fs?.form || this;
			form._cdaCloseForm?.();
			const load = () => form._cdaLoadAddresses?.();
			load();
			setTimeout(load, 400);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#type' }, types: [types.opt_person_type(), types.datalist()] },
		{ properties: { selector: '#nick' }, types: [types.name()] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#cpf' }, types: [types.cpf()] },
		{ properties: { selector: '#cnpj' }, types: [types.cnpjOrGsnetCode('#customer')] },
		{ properties: { selector: '#ie' }, types: [types.ie()] },
		{ properties: { selector: '#ie_type' }, types: [types.opt_ie_type(), types.datalist()] },
		{ properties: { selector: '#phone' }, types: [types.phone()] },
		{ properties: { selector: '#email' }, types: [types.email()] },
		{ properties: { selector: '#billing_address_id' }, types: [] },
		{ properties: { selector: '#billing_address_street' }, types: [types.name()] },
		{ properties: { selector: '#billing_address_number' }, types: [types.name()] },
		{ properties: { selector: '#billing_address_complement' }, types: [types.name()] },
		{ properties: { selector: '#billing_address_district' }, types: [types.name()] },
		{ properties: { selector: '#billing_address_state' }, types: [types.pubsub(), types.opt_uf(), types.datalist()] },
		{ properties: { selector: '#billing_address_city_id' }, types: [types.pubsub(), types.name(), types.observer('billing_address_state'), types.obs_load_cities(), types.obs_filter_cities('billing_address_state')] },
		{ properties: { selector: '#billing_address_zipcode' }, types: [types.cep(), types.obs_cep()] },
		{ properties: { selector: '#delivery_address_id' }, types: [] },
		{ properties: { selector: '#delivery_address_street' }, types: [types.name()] },
		{ properties: { selector: '#delivery_address_number' }, types: [types.name()] },
		{ properties: { selector: '#delivery_address_complement' }, types: [types.name()] },
		{ properties: { selector: '#delivery_address_district' }, types: [types.name()] },
		{ properties: { selector: '#delivery_address_state' }, types: [types.pubsub(), types.opt_uf(), types.datalist()] },
		{ properties: { selector: '#delivery_address_city_id' }, types: [types.pubsub(), types.name(), types.observer('delivery_address_state'), types.obs_load_cities(), types.obs_filter_cities('delivery_address_state')] },
		{ properties: { selector: '#delivery_address_zipcode' }, types: [types.cep(), types.obs_cep()] },
		{ properties: { selector: '#delivery_term' }, types: [types.number(0)] },
		{ properties: { selector: '#payment_term_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('payment_terms')] },
		{ properties: { selector: '#payment_method' }, types: [types.opt_payment_method(), types.datalist()] },
		{ properties: { selector: '#price_list_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('price_lists')] },
		{ properties: { selector: '#route_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('customer_routes', { labels: ['code', 'name'], sep: ' — ', filter: (r) => !(r.is_disabled === true || r.is_disabled === 1 || r.is_disabled === '1') })] },
		{ properties: { selector: '#is_end_consumer' }, types: [types.checkbox()] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
	]

};

